<template>
  <span class="text-default font-weight-semibold letter-icon-title">
    <template v-if="props.loading">
      <i class="icon-spinner9 spinner"/>
    </template>
    <template v-else>
      <i class="transition icon-arrow-right13" :class="{ 'rotate-90': props.isExpanded }"/>
    </template>
  </span>
</template>

<script setup>
  const props = defineProps({
    isExpanded: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  });
</script>
